import React from "react";
import banner from "../../../assets/images/osportwears/banner.jpg";
import mobileBanner from "../../../assets/images/osportwears/Phone bannner .jpg";
const Banner = () => {
  return (
    <div className=" overflow-hidden w-full bg-slate-50 object-cover">
      <img src={banner} className=" hidden md:block  object-contain " alt="" />
      <img src={mobileBanner} className=" md:hidden  object-contain " alt="" />
    </div>
  );
};

export default Banner;
